import { Col, Row } from "antd";
import InputComponent from "../../../components/InputComponent";
import { InputStyle } from "./constants";
import TextareaComponent from "../../../components/TextareaComponent";
import { useDiscoveryContext } from "../../../context/DiscoveryContext/DiscoveryContext";
import { useEffect } from "react";

type NewsContentDetailProps = {
  isEnContent: boolean;
};

const NewsContentDetail: React.FC<NewsContentDetailProps> = ({ isEnContent }) => {
  const DETAIL_INDEX = isEnContent ? 1 : 0;
  const { discoveryData, setDiscoveryData } = useDiscoveryContext();
  

  const handleTitleChange = (value: string) => {
    setDiscoveryData(prevState => {

      return {
        ...prevState,
        discoveryDetails: prevState?.discoveryDetails?.map((item, idx) => {
          if (idx === DETAIL_INDEX) {
            return {
              ...item,
              title: value
            };
          }
          return item;
        })
      };
    });
  };

  const handleDescriptionChange = (value: string) => {
    setDiscoveryData(prevState => {
      return {
        ...prevState,
        discoveryDetails: prevState?.discoveryDetails?.map((item, idx) => {
          if (idx === DETAIL_INDEX) {
            return {
              ...item,
              description: value
            };
          }
          return item;
        })
      };
    });
  };
 

  return (
    <>     
      <Row gutter={20}>
        <Col span={12}>
          <InputComponent
            title={"Başlık"}
            placeholder=""
            value={discoveryData?.discoveryDetails[DETAIL_INDEX]?.title}
            style={InputStyle}
            isRequired
            onChange={(e) => handleTitleChange(e.target.value)}
          />
        </Col>
        <Col span={12}>
          <TextareaComponent
            title={"Açıklama"}
            placeholder=""
            value={discoveryData?.discoveryDetails[DETAIL_INDEX]?.description}
            isRequired
            onChange={(e) => handleDescriptionChange(e.target.value)}
            rows={8}
          />
        </Col>
      </Row>
    </>
  );
};

export default NewsContentDetail;
